import * as React from "react";
import InputField from "../../generic/inputField";
import "../../../assets/scss/components/login/generic/newPasswordField.scss";
import { betweenNChars, exceptSplChar, atleast1SplChar, notEqualTo, atleast1Alpha1Num } from "../../utils/regex";
import { getPreLoginData } from "../../service/login/loginService";

export interface INewPasswordFieldProps {
	onChange: (value: string, error: string) => void;
	onBlur: (error: string) => void;
}

const NewPasswordField: React.FC<INewPasswordFieldProps> = props => {
	// show password or not
	const [showPassword, setShowPassword] = React.useState(false);

	// show ticks section
	const [showConditions, setShowConditions] = React.useState(false);

	// if true, then show cross instead of grey ticks
	const [showCross, setShowCross] = React.useState(false);

	// value in input field
	const [val, setVal] = React.useState("");

	// all the validations
	const validationArr = [
		{ name: "Should be between 6 to 12 characters", regex: betweenNChars(6, 12) },
		{ name: "Should be alphanumeric", regex: atleast1Alpha1Num },
		{ name: "Should have atleast one acceptable special character", regex: [exceptSplChar, atleast1SplChar] },
		{ name: "Cannot be same as login ID", regex: notEqualTo(getPreLoginData("userID"), "i") }
	];

	// stores the validity of validationArr
	const [isValid, setIsValid] = React.useState(new Array(validationArr.length).fill(false));

	function handleOnChange(value: string) {
		// if changed for the first time then show the ticks section and keep showing afterwards
		if (!showConditions) {
			setShowConditions(true);
		}

		setVal(value);

		props.onChange(value, findError(value));
	}

	function findError(value: string) {
		// validate all the regex and get the new boolean array containing validity
		const isValidCopy = validateRegex(value);
		setIsValid(isValidCopy);

		// find the first error and return that
		let error = "";
		isValidCopy.find((valid, index) => {
			if (!valid) {
				error = validationArr[index].name;
			}
			return !valid;
		});
		return error;
	}

	function validateRegex(value: string) {
		// loop over validationArr and validate
		return validationArr.map(validation => {
			// if validation.regex is an array, then loop over all the elements
			if (Array.isArray(validation.regex)) {
				// if any regex tests false, then we have to return false
				// if any regex tests false, find will return that regex; otherwise it returns undefined
				return validation.regex.find(regex => !regex.test(value)) === undefined;
			}

			// if validation.regex is regex
			return validation.regex.test(value);
		});
	}

	function handleBlur() {
		setShowCross(true);
		props.onBlur(findError(val));
	}

	return (
		<>
			<InputField
				type={showPassword ? "text" : "password"}
				onChange={handleOnChange}
				onBlur={handleBlur}
				className={"login_inp" + (showConditions ? "" : " mg-b40")}
				placeholder="Eg:5678987"
				suffix={<i className={`edel-icon-eye${showPassword ? "-cross" : ""} icon`} onClick={() => setShowPassword(!showPassword)} />}
				required
			/>

			{showConditions && (
				<ul className="password_cond">
					{validationArr.map((validation, index) => (
						<li key={validation.name} className={index < validationArr.length - 1 ? "mg-b15" : "mg-b40"}>
							<span
								// show green tick if valid
								// show red cross if not valid and blurred
								// show grey tick otherwise
								className={
									"ib mg-r10 " +
									(isValid[index] ? "edel-icon-tick tick green" : showCross ? "edel-icon-close cross" : "edel-icon-tick tick grey")
								}
							></span>
							<label>{validation.name}</label>
						</li>
					))}
				</ul>
			)}
		</>
	);
};

export default NewPasswordField;
